import React,{ useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePermissions } from "../../customHooks";
import Page from "../../components/general/page";
import Uploader from "../../components/uploader";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
// const Uploader = React.lazy(() => import("../../components/uploader"));

const UploadPage = ({ pageRef}) => {
  const navigate = useNavigate();
  const companies = useSelector(state => state.company.companies);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const main = useSelector(state => state.main);
  const accountantIdSelected = main.accountantIdSelected;
  const companySelected= main.companySelected;
  const clientIdSelected= main.clientIdSelected;
  const myType= main.myType;
  const intl = useIntl();

  const isPermissionWebUpload = usePermissions(currentPermissions);
  const ragioneSociale = companies.find(el => {
    return el.codiceFiscale === companySelected;
  }).ragioneSociale;

  /**
   * L'utente non ha permesso di caricare documenti quindi viene rediretto
   * nuovamente in home
   * */
  useEffect(() => {
    if (myType !== "STUDIO" && !isPermissionWebUpload) {
      navigate("/");
    }
  }, []);

  return (myType === "STUDIO" || isPermissionWebUpload) && (
    <Page
      pageRef={pageRef}      
      title={<FormattedMessage id="upload.title" />}
      subtitle={ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}
      className={"contentStructure"}
      style={{ display: "flex", flexDirection: "column" }}
    >      
      <Uploader
        accountantIdSelected={accountantIdSelected}
        clientIdSelected={clientIdSelected}        
        myType={myType}
      />      
    </Page>
  );
};

export default UploadPage;
